var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wac-typography',{class:['wac-cms-social-media-share'],attrs:{"element":"a","variant":"body-5","href":_vm.processedUrl,"title":_vm.title}},[_c('wac-icon',{attrs:{"variant":_vm.icon,"size":"large"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }